export default "__VITE_ASSET__Cs$7Paeu__"